<template>
    <div v-html="payUrl"></div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast } from 'vant';
import { Dialog } from 'vant';
export default {
    data() {
        return {
            payUrl: '',
            orderNo: ''
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            if (this.$route.query.orderNo) {
                wxRequest("sim/select/ali/url", { orderNo: this.$route.query.orderNo }, "post").then(res => {
                    if (res.data.code == 200) {
                        this.payUrl = res.data.data;
                        this.$nextTick(() => {
                            document.forms[0].submit()
                        })
                    } else {
                        Dialog.alert({ title: "提示", message: res.data.message });
                    }
                })
            } else {
                Dialog.alert({ title: "提示", message: '订单不存在！请重新支付' });
            }

        }
    }
}
</script>
